module.exports = __webpack_public_path__ + "media/images/iconUp__inactive-50a40e95490fa0bacacaed0f8f800a13.png";